(function () {
  'use strict';

  angular.module('app').component('packageContentDetail', packageContentDetail());

  function packageContentDetail() {
    return {
      bindings: {
        item: '=',
        packageId: '<',
        onPackageContentSaved: '&',
        onPackageContentCanceled: '&',
        websiteId: '<',
        defaultLanguage: '<',
        additionalLanguages: '<',
      },
      controller: PackageContentDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/package-contents/package-content-detail/package-content-detail.component.html',
    };
  }

  PackageContentDetailComponent.$inject = [
    'UtilService',
    'SessionService',
    'PackageContentService',
    'PackageService',
    'TagService',

    // Angular downgraded service
    'ng2Router',
  ];

  function PackageContentDetailComponent(
    UtilService,
    SessionService,
    PackageContentService,
    PackageService,
    TagService,

    // Angular downgraded service
    ng2Router
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);
    var cropedImage = { file: null };

    // Methods
    vm.tagTransform = tagTransform;
    vm.checkTagOptions = checkTagOptions;

    vm.selectParentPackage = selectParentPackage;
    vm.updateSeoTitle = updateSeoTitle;
    vm.setSeoTitle = setSeoTitle;
    vm.updateSeoDescription = updateSeoDescription;
    vm.setSeoDescription = setSeoDescription;

    //vm.editPackageContent = editPackageContent;
    vm.cancelEdit = cancelEdit;
    vm.savePackageContent = savePackageContent;
    vm.cancel = cancel;
    vm.openPackageContentTranslation = openPackageContentTranslation;
    vm.openLogo = openLogo;

    vm.$onInit = function () {
      if (vm.item.id) {
        // Edit
        vm.editMode = true;

        vm.flashMessage = vm.UtilService._displayFlashMessage();

        vm.urlEmbedVideo = vm.UtilService.embedYouTubeVideo(vm.item.url_video);

        vm.itemName = vm.item.name;
        vm.labelAddLogo = vm.item.logo.url ? 'CHANGE_PHOTO' : 'ADD_PHOTO';
        vm.originalItem = angular.copy(vm.item);
      } else {
        // New
        if (vm.packageId) {
          vm.item.package_id = vm.packageId; // optional from modal
        }

        vm.item.website_id = vm.websiteId;
        vm.isUrlRequiredisUrlValid = false;
        vm.item.url = '';

        vm.item.published = false;

        vm.labelAddLogo = 'ADD_PHOTO';
      }

      var companyWebsites = SessionService.getSelectedAccountCompany().websites;

      vm.websiteName = vm.UtilService.findItemInArray(companyWebsites, 'id', vm.websiteId).name;
      vm.tabs = vm.UtilService.websiteTabs(vm.websiteId);

      // Initializers
      getPackagesContents();
      getTags(vm.defaultLanguage);
    };

    function cancelEdit() {
      vm.cancel();
    }

    function getPackages(packageIds) {
      PackageService.getPackages({ get: 'selector', skip_check_role: true }).then(function (data) {
        vm.packages = [];

        data.items.forEach(function (pack) {
          for (var i = 0; i < packageIds.length; i++) {
            var packageId = packageIds[i];
            if (pack.id === packageId) {
              if (vm.item.package_id === packageId) {
                pack.current = true;
              } else {
                pack.inUse = true;
              }

              break;
            }
          }

          vm.packages.push(pack);
        });
      });
    }

    function getPackagesContents() {
      var filterCriteria = {
        get: 'active',
        skip_check_role: true,
      };

      PackageContentService.getPackagesContents(vm.item.website_id, filterCriteria).then(function (
        data
      ) {
        var packageIds = [];

        data.items.forEach(function (content) {
          packageIds.push(content.package_id);
        });

        getPackages(packageIds);
      });
    }

    function selectParentPackage(pack) {
      if (!vm.item.id) {
        // Create mode
        vm.item.name = pack.name;
        updateSeoTitle();
      }
    }

    // ----- SEO ----- //
    function updateSeoTitle() {
      if (!vm.item.seo_title_filled) {
        vm.item.seo_title = vm.item.name;
      }
    }

    function setSeoTitle() {
      vm.item.seo_title_filled = vm.item.seo_title ? true : false;
    }

    function updateSeoDescription() {
      if (!vm.item.seo_description_filled) {
        vm.item.seo_description = vm.item.description.replace(/<\/?[^>]+(>|$)/g, ''); // text only
      }
    }

    function setSeoDescription() {
      vm.item.seo_description_filled = vm.item.seo_description ? true : false;
    }

    function openLogo() {
      let logoSaved = (cropedImageObj) => {
        cropedImage = cropedImageObj;

        if (vm.editMode) {
          PackageContentService.updateLogo(vm.item, cropedImage);
        } else {
          var img = document.getElementById('logo-image-preview'); // <HTMLInputElement>
          img.src = URL.createObjectURL(cropedImage.file);
        }
      };

      PackageContentService.openLogo(vm.item, logoSaved);
    }

    // ----- TAGS -----

    function getTags(lang) {
      TagService.getTags({ skip_check_role: true, by_lang: lang }).then(function (data) {
        vm.tags = data.items;
      });
    }

    function tagTransform(name) {
      return TagService.tagTransform(name, vm.defaultLanguage);
    }

    function checkTagOptions(tag) {
      vm.tagOptions = TagService.checkTagOptions(tag, vm.tags);
    }

    // Create / udpate package content
    function savePackageContent(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid || vm.item.url === '') {
        vm.isUrlRequired = true;
        vm.serverErrors = [];
        vm.formErrors = true;

        vm.UtilService.scrollToTop();

        return;
      }

      var successCallback = function () {
        vm.sendingForm = true;
        PackageContentService.savePackageContent(vm.item, vm.defaultLanguage, cropedImage).then(
          function (response) {
            var response = response.data;

            vm.urlEmbedVideo = vm.UtilService.embedYouTubeVideo(response.url_video);

            if (!vm.editMode) {
              // Create
              vm.onPackageContentSaved({ item: response });
            } else {
              // Edit
              vm.flashMessage = vm.UtilService._clearFlashMessage();

              vm.itemName = response.name;
              vm.originalItem = angular.copy(vm.item);
            }

            vm.sendingForm = false;

            vm.UtilService.scrollToTop();
          },
          function (response) {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.data.errors);

            if (response.data.error) {
              vm.serverErrors.publish = response.data.error;
            }

            vm.formErrors = true;
            vm.UtilService.scrollToTop();

            vm.sendingForm = false;
          }
        );
      };

      const callback = (response) => {
        if (response === 'edit') {
          vm.UtilService.scrollToTop();

          return;
        }

        if (response === 'generate') {
          vm.item.url = UtilService.prototype.generateURL(vm.item);
        }

        successCallback();
      };

      if (vm.item.id && vm.item.name !== vm.originalItem.name) {
        vm.UtilService.openProductsChangeUrlModal(callback);
      } else {
        successCallback();
      }
    }

    function cancel() {
      vm.onPackageContentCanceled({ item: vm.item });
    }

    function openPackageContentTranslation() {
      PackageContentService.openPackageContentTranslation(
        vm.item.id,
        vm.websiteName,
        vm.additionalLanguages
      );
    }

    // function isUrlValid() {
    //   if (vm.item.url === '') vm.isUrlRequired = true;
    //   return;
    // }

    vm.goToWebsiteDetail = (websiteId) => {
      ng2Router.navigate(['/ng/websites', websiteId]);
    };
  }
})();
